import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BellIcon from '../../../Visuals/Icons/BellIcon.icon';
import TertiaryButton from '../../../Components/Buttons/TertiaryButton/TertiaryButton.component';
import { AlertsContainer, EachAlert, AlertDetails } from './Alerts.styles';

const Alerts = ({ alerts }) => {
  const [showAlerts, setShowAlerts] = useState(true);

  const handleAlerts = () => {
    setShowAlerts(!showAlerts);
  };

  return (
    <AlertsContainer>
      <div className="spaceBetween m1R m1T m1L m1B">
        <h4
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          Alerts <BellIcon />
        </h4>
        {showAlerts ? (
          <TertiaryButton span="hide alerts" functionName={handleAlerts} />
        ) : (
          <TertiaryButton span="show alerts" functionName={handleAlerts} />
        )}
      </div>
      {showAlerts && (
        <>
          {alerts?.length > 0 ? (
            alerts?.some(
              (a) =>
                a?.employeeName && // Ensure the alert has a valid employee name
                ((a?.expiringCerts && a.expiringCerts?.length > 0) ||
                  (a?.pendingCourses && a.pendingCourses?.length > 0))
            ) ? (
              alerts?.map((a, i) => {
                if (
                  a?.employeeName && // Ensure the alert has a valid employee name
                  ((a?.expiringCerts && a?.expiringCerts?.length > 0) ||
                    (a?.pendingCourses && a?.pendingCourses?.length > 0))
                ) {
                  return (
                    <EachAlert key={i}>
                      <div className="flexGap">
                        <p>Employee Name:</p>
                        <span>{a?.employeeName}</span>
                      </div>
                      {a?.expiringCerts?.length > 0 && (
                        <AlertDetails>
                          <p>Expiring Certifications:</p>
                          <div>
                            {a?.expiringCerts?.map((cert, index) => (
                              <span key={cert?._id}>
                                {cert?.courseName}
                                {index !== a?.expiringCerts?.length - 1 && ','}
                              </span>
                            ))}
                          </div>
                        </AlertDetails>
                      )}
                      {a?.pendingCourses?.length > 0 && (
                        <AlertDetails>
                          <p>Pending Courses:</p>
                          <div>
                            {a?.pendingCourses?.map((course, index) => (
                              <span key={course?._id}>
                                {course?.courseName}
                                {index !== a?.pendingCourses?.length - 1 && ','}
                              </span>
                            ))}
                          </div>
                        </AlertDetails>
                      )}
                    </EachAlert>
                  );
                }
                return null;
              })
            ) : (
              <p className="m1L m1B">There are currently no alerts</p>
            )
          ) : (
            <p className="m1L m1B">There are currently no alerts</p>
          )}
        </>
      )}
    </AlertsContainer>
  );
};

Alerts.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      employeeName: PropTypes.string,
      expiringCerts: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string.isRequired,
          courseName: PropTypes.string.isRequired,
        })
      ),
      pendingCourses: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string.isRequired,
          courseName: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};

export default Alerts;
